// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__c4V7X","info":"PatientInfo_info__1_8-X"};